import { AbstractControl, ValidatorFn } from '@angular/forms';

export const enableControl = (control: AbstractControl, enabled = true, opts?: {
  onlySelf?: boolean;
  emitEvent?: boolean;
}): void => {
  return enabled ? control.enable(opts) : control.disable(opts);
};

export const enableValidators = (control: AbstractControl, validators: ValidatorFn | ValidatorFn[], enabled = true, opts?: {
  onlySelf?: boolean;
  emitEvent?: boolean;
}) => {
  if (enabled) {
    control.addValidators(validators);
  } else {
    control.removeValidators(validators);
  }
  control.updateValueAndValidity(opts);
};
